import { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectFeatureFlagNotifyHitlBuild } from '../../redux/features/config/config.selector';
import logger from '../../utils/logger';

export function useBuildNumberCheck(interval = 60000) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const notifyHitlBuild = useAppSelector(selectFeatureFlagNotifyHitlBuild);

  useEffect(() => {
    if (!notifyHitlBuild) {
      return;
    }

    const checkBuildNumber = async () => {
      try {
        const res = await fetch('/buildNumber.json', { cache: 'no-store' });
        const { value } = await res.json();

        const currentBuildNumber = (window as any).__HITL_BUILD_NUMBER__;
        if (value !== currentBuildNumber) {
          setUpdateAvailable(true);
        }
      } catch (e: any) {
        logger.error({
          message: 'Failed to check build number',
          error: e?.message,
        });
      }
    };

    const id = setInterval(checkBuildNumber, interval);
    return () => clearInterval(id);
  }, [interval, notifyHitlBuild]);

  const refreshApp = () => {
    window.location.reload();
  };

  const ignoreUpdate = () => {
    setUpdateAvailable(false);
  };

  return {
    updateAvailable,
    setUpdateAvailable,
    refreshApp,
    ignoreUpdate,
  };
}
